export enum AppMode
{
    Easy = 0,
    Expert = 1
}